import { render, staticRenderFns } from "./SelectTipoDeProjeto.vue?vue&type=template&id=6e56409e"
import script from "./SelectTipoDeProjeto.vue?vue&type=script&lang=js"
export * from "./SelectTipoDeProjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports